export default "__VITE_ASSET__5d4faeed__"